export default __webpack_public_path__ + "static/CentraNo2-Thin-aab0b43a2ffa4081e4dd734e0c87049b.woff";